// extracted by mini-css-extract-plugin
module.exports = {"allCarsResult":"UnbxdCards-module__allCarsResult","cardsContainer":"UnbxdCards-module__cardsContainer"};